// test396
(396 && 0);
